import { render, staticRenderFns } from "./LinkModel.vue?vue&type=template&id=34cabcaa&scoped=true&"
import script from "./LinkModel.vue?vue&type=script&lang=js&"
export * from "./LinkModel.vue?vue&type=script&lang=js&"
import style0 from "./LinkModel.vue?vue&type=style&index=0&id=34cabcaa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34cabcaa",
  null
  
)

export default component.exports